import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let AppChains = {
  /**
   * AppChain List
   */
  async AppChainList (context, payload = null) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()

      for (let key in payload) {
        if (key == "whereFilter") {
          postData.append("filter", JSON.stringify(payload[key]))
        }
        else if (payload[key] || typeof payload[key] == "number") {
          postData.append(key, payload[key])
        }
      }

      return await request.curl(context, "app_chain_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at AppChainList() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * AppChain View
   */
  async AppChainView (context, payload) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."
      console.log("Payload ", payload)

      let postData = new FormData()

      for (let key in payload) {
        console.log("KWY ", payload)
        if (payload[key] || typeof payload[key] == "number") {
          postData.append(key, payload[key])
        }
      }

      return await request.curl(context, "app_chain_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at AppChainView() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * AppChain Add
   */
  async AppChainAdd (context, AppChainObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in AppChainObj) {
        postData.append(key, AppChainObj[key])
      }

      return await request.curl(context, "app_chain_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at AppChainAdd() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * AppChain Edit
   */
  async AppChainEdit (context, AppChainObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in AppChainObj) {
        postData.append(key, AppChainObj[key])
      }

      return await request.curl(context, "app_chain_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at AppChainEdit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * AppChain Delete
   */
  async AppChainDelete (context, AppChainIdArray) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      let AppChainId = AppChainIdArray.join(",")
      postData.append("app_id", AppChainId)

      return await request.curl(context, "app_chain_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at AppChainDelete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * AppChain FilterList
   */
  async AppChainFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "app_chain_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at app_chain_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  AppChains
}
